export const DocumentIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3327 8.33464V12.5013C18.3327 16.668 16.666 18.3346 12.4993 18.3346H7.49935C3.33268 18.3346 1.66602 16.668 1.66602 12.5013V7.5013C1.66602 3.33464 3.33268 1.66797 7.49935 1.66797H11.666"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 8.33464H14.9993C12.4993 8.33464 11.666 7.5013 11.666 5.0013V1.66797L18.3327 8.33464Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
